import React, { ReactNode } from 'react';
import { makeStyles } from '@mui/styles';

const useStyles = makeStyles({
  container: {
    backgroundColor: '#fff',
    borderRadius: '8px 8px 0 0',
    padding: 15,
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
});

interface FilterBoxProps {
  children: ReactNode;
}

const FilterBox: React.FC<FilterBoxProps> = ({ children }) => {
  const classes = useStyles();

  return (
    <>
      <div className={classes.container}>{children}</div>
    </>
  );
};

export default FilterBox;
